import React, { Component } from "react";
import * as PropTypes from "prop-types";
import { Modal, Form, Input, Spin, message } from "antd";

import moment from "moment";

import {
	timeCardService,
} from "./../../../../redux/services";

class ModalObservacao extends Component {
	static propTypes = {
		visible: PropTypes.bool.isRequired,
		onComplete: PropTypes.func.isRequired,
		onClose: PropTypes.func.isRequired,
	};

	constructor(props) {
		super(props);

		this.state = {
			isLoading: false,
			isSending: false,
		}
	}

	resetFields = () => {
	};

	onClose = () => {
		// Reset fields
		this.resetFields();

		// Callback
		this.props.onClose();
	};

	onOpen = () => {
		this.setState({
			isLoading: true,
		});

		timeCardService
			.getObservacao({
				cartao_ponto_id: this.props.cartaoPontoId,
			})
			.then((response) => {
				this.setState({
					isLoading: false,
				});

				if (this.form) {
					this.form.setFieldsValue({
						observacao: response.data.observacao
					});
				}
			})
			.catch((data) => {
				this.setState({
					isLoading: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	}

	onSubmit = () => {
		this.form.validateFields().then((values) => {
			this.setState({
				isSending: true
			});

			timeCardService
				.updateObservacao({
					cartao_ponto_id: this.props.cartaoPontoId,
					observacao: values.observacao,
				})
				.then((response) => {
					this.setState({
						isSending: false,
					});

					// Reset fields
					this.resetFields();

					// Success message
					message.success("Observação do cartão ponto atualizada com sucesso.");

					// Callback
					this.props.onComplete();
				})
				.catch((data) => {
					this.setState({
						isSending: false,
					});

					Modal.error({
						title: "Ocorreu um erro!",
						content: String(data),
					});
				});
		});
	}

	render() {
		const { visible } = this.props;

		const { isLoading, isSending } = this.state;
	
		return (
			<Modal
				open={visible}
				title={(
					<div className="time-card-modal-header">
						<span className="time-card-modal-header-icon"><i className="fal fa-comment-dots" /></span>
						<div className="time-card-modal-title">Observação do cartão ponto</div>
					</div>
				)}
				wrapClassName="modal-scroll"
				className="time-card-modal time-card-modal-divided"
				destroyOnClose={true}
				width={640}
				onCancel={this.onClose}
				maskClosable={false}
				okText={isSending ? "Aplicando" : "Aplicar"}
				cancelButtonProps={{disabled: isLoading || isSending}}
				onOk={this.onSubmit}
				confirmLoading={isSending}
				keyboard={!isSending}
				closable={!isSending && !isLoading}
				centered
			>
				<Spin spinning={isLoading} indicator={<i className="fad fa-spinner-third fa-spin fa-2x" />}>
					<Form
						ref={el => this.form = el}
						layout="vertical"
						scrollToFirstError
						onFinish={this.onFinish}
						disabled={isLoading || isSending}
					>
						<Form.Item label="Data" className="time-card-readonly-date">
							<Input
								disabled
								prefix={<i className="fal fa-calendar-alt" />}
								value={moment(this.props.dataDia).format("DD/MM/YYYY")}
							/>
						</Form.Item>
						<Form.Item label="Observação" name="observacao">
							<Input.TextArea rows={8} maxLength={500} showCount placeholder="Digite sua observação aqui..." />
						</Form.Item>
					</Form>
				</Spin>
			</Modal>
		)
	}
}

export default ModalObservacao;